<section class="generate-card">
  <h4 class="font-semibold mb-1">Wygeneruj umowę</h4>
  <p class="text-sm text-gray-500 mb-3">
    Umowa zostanie wypełniona aktualnymi danymi kursanta (zakładka „Dane podstawowe”, w tym adres), szkoły i
    wybranego kursu, a następnie zapisana na liście poniżej.
  </p>
  <div class="generate-card__row">
    <!-- One picker per student: browsing to the next student starts with an empty choice. -->
    <app-agreement-picker
      *ngFor="let guid of [studentGuid]"
      class="flex-1 min-w-0"
      [examCategoryGuid]="examCategoryGuid"
      (selectionChange)="selection = $event"
    ></app-agreement-picker>
    <p-button
      label="Wygeneruj i pobierz"
      icon="pi pi-file-pdf"
      [loading]="generating"
      [disabled]="!selection.agreementGuid"
      (onClick)="generate()"
      data-clarity-unmask="true"
    ></p-button>
  </div>
</section>

<section class="mt-4">
  <h4 class="font-semibold mb-2">Umowy kursanta</h4>
  <p *ngIf="loading" class="text-gray-500">Pobieranie umów…</p>
  <table *ngIf="!loading && agreements.length > 0" class="student-agreements">
    <thead>
      <tr>
        <th>Umowa</th>
        <th>Kurs</th>
        <th>Wygenerowano</th>
        <th class="col-actions"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let agreement of agreements">
        <td>{{ agreement.agreementName }}</td>
        <td>{{ agreement.courseName || '—' }}</td>
        <td>
          {{ agreement.created | date: 'dd.MM.yyyy HH:mm' }}
          <div *ngIf="agreement.createdByEmail" class="text-xs text-gray-500">{{ agreement.createdByEmail }}</div>
        </td>
        <td class="col-actions">
          <p-button
            icon="pi pi-download"
            [text]="true"
            pTooltip="Pobierz PDF"
            tooltipPosition="bottom"
            ariaLabel="Pobierz PDF"
            [loading]="pdfLoadingGuid === agreement.guid"
            [disabled]="pdfLoadingGuid !== null"
            (onClick)="download(agreement)"
            data-clarity-unmask="true"
          ></p-button>
          <p-button
            icon="pi pi-trash"
            [text]="true"
            severity="secondary"
            pTooltip="Usuń (wygenerowaną przez pomyłkę)"
            tooltipPosition="bottom"
            ariaLabel="Usuń umowę"
            (onClick)="remove(agreement)"
            data-clarity-unmask="true"
          ></p-button>
        </td>
      </tr>
    </tbody>
  </table>
  <p *ngIf="!loading && agreements.length === 0" class="text-gray-500">Dla tego kursanta nie wygenerowano jeszcze umowy.</p>
</section>

<p-confirmDialog key="studentAgreementConfirm" [style]="{ width: '480px' }" appendTo="body"></p-confirmDialog>
